export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'fatal';

const LogLevels = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  fatal: 5,
};

export function isGreaterOrEqual(a: LogLevel, b: LogLevel): boolean {
  return LogLevels[a] >= LogLevels[b];
}
